import jsPDF from "jspdf";
import 'jspdf-autotable'

function convertToTable(json) {
    const head = [];
    const body = [];

    head.push(Object.keys(json[0]));

    for(let i = 0; i < json.length; i++) {
        const values = Object.values(json[i]).map(value => {
            if(typeof value === 'string' && value.length > 500) {
                value = value.substring(0, 500) + "...";
            }
            return value;
        });
        body.push(values);
    }

    return { head, body };
}

export const downloadJsonAsPdf = function (json, orientation = "l") {
    const doc = new jsPDF({
        orientation: orientation
    });
    doc.autoTable(convertToTable(json));
    doc.save("sheet.pdf");
};
